import { render, staticRenderFns } from "./ESGscoretimeline2.vue?vue&type=template&id=8d5a7396&scoped=true"
import script from "./ESGscoretimeline2.vue?vue&type=script&lang=js"
export * from "./ESGscoretimeline2.vue?vue&type=script&lang=js"
import style0 from "./ESGscoretimeline2.vue?vue&type=style&index=0&id=8d5a7396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5a7396",
  null
  
)

export default component.exports